@if (content) {
<div class="w-12 bg-col-w height-100 flex flex-column flex-middle flex-justify-center p-a-8 p-a-4-m p-a-4-s">
    <p class="h2 center"
       *iCms="'title' of content"></p>
    <p class="p1 m-t-6 center "
       *iCms="'subtitle' of content"></p>
    <button class="w-12 button m-t p1"
            (click)="login()">{{'Sign up'| translate}}</button>
    <a [routerLink]="'/'"
       class="w-12 button-1 m-t-6 p1">
        <span>{{'Continue shopping' | translate}}</span></a>
</div>
}
